import { http, onSuccess, onFail } from "./http";

export const updateEvent = (id, data) =>
    http.put(`/api/cp/event/${id}`, data)
        .then(onSuccess, onFail);